/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 16.04.13
 * Time: 09:58
 */

/**
 * Enumeration for all private offer states
 */
export class PrivateOfferStateEnum {
    // add missing states and adjust in finished State and failed state if necessary

    public static PRECONDITION: PrivateOfferStateEnum = new PrivateOfferStateEnum(10);
    public static PRECONDITION_FAILED: PrivateOfferStateEnum = new PrivateOfferStateEnum(410);

    public static QUEST_PENDING: PrivateOfferStateEnum = new PrivateOfferStateEnum(21);
    public static QUEST_STARTED: PrivateOfferStateEnum = new PrivateOfferStateEnum(22);
    public static OFFER_READY: PrivateOfferStateEnum = new PrivateOfferStateEnum(40);
    public static OFFER_PENDING: PrivateOfferStateEnum = new PrivateOfferStateEnum(41);

    public static QUEST_REJECTED: PrivateOfferStateEnum = new PrivateOfferStateEnum(421);
    public static QUEST_FAILED: PrivateOfferStateEnum = new PrivateOfferStateEnum(422);
    public static QUEST_EXPIRED: PrivateOfferStateEnum = new PrivateOfferStateEnum(423);
    public static OFFER_REJECTED: PrivateOfferStateEnum = new PrivateOfferStateEnum(441);
    public static OFFER_FAILED: PrivateOfferStateEnum = new PrivateOfferStateEnum(442);
    public static OFFER_EXPIRED: PrivateOfferStateEnum = new PrivateOfferStateEnum(443);
    public static OFFER_ACCEPTED: PrivateOfferStateEnum = new PrivateOfferStateEnum(240);
    public static OFFER_SUCCEEDED: PrivateOfferStateEnum = new PrivateOfferStateEnum(200);
    public static OFFER_CANCELED: PrivateOfferStateEnum = new PrivateOfferStateEnum(400);
    public static CANCELED_BY_ABTEST: PrivateOfferStateEnum = new PrivateOfferStateEnum(401);

    /**
     * Returns the enumeration object, which represents the server offer state id
     * @param serverEventId
     * @return
     */
    public static getEnumByServerEventID(serverEventId: number): PrivateOfferStateEnum {
        switch (serverEventId) {
            case 21:
                return PrivateOfferStateEnum.QUEST_PENDING;
            case 22:
                return PrivateOfferStateEnum.QUEST_STARTED;
            case 40:
                return PrivateOfferStateEnum.OFFER_READY;
            case 41:
                return PrivateOfferStateEnum.OFFER_PENDING;

            case 10:
                return PrivateOfferStateEnum.PRECONDITION;
            case 410:
                return PrivateOfferStateEnum.PRECONDITION_FAILED;

            case 421:
                return PrivateOfferStateEnum.QUEST_REJECTED;
            case 422:
                return PrivateOfferStateEnum.QUEST_FAILED;
            case 423:
                return PrivateOfferStateEnum.QUEST_EXPIRED;
            case 441:
                return PrivateOfferStateEnum.OFFER_REJECTED;
            case 442:
                return PrivateOfferStateEnum.OFFER_FAILED;
            case 443:
                return PrivateOfferStateEnum.OFFER_EXPIRED;
            case 240:
                return PrivateOfferStateEnum.OFFER_ACCEPTED;
            case 200:
                return PrivateOfferStateEnum.OFFER_SUCCEEDED;
            case 400:
                return PrivateOfferStateEnum.OFFER_CANCELED;
            case 401:
                return PrivateOfferStateEnum.CANCELED_BY_ABTEST;
        }
        return null;
    }

    private _serverEventId: number;

    constructor(eventId: number) {
        this._serverEventId = eventId;
    }

    public toString(): string {
        return "StateID: " + this._serverEventId;
    }

    /**
     * Returns if the state is a finish state
     * @param state
     * @return
     */
    public static isFinishedState(state: PrivateOfferStateEnum): boolean {
        return !state || PrivateOfferStateEnum.isFailedState(state) || state === PrivateOfferStateEnum.OFFER_SUCCEEDED;
    }

    /**
     * Returns if the state is a fail state
     * @param state
     * @return
     */
    public static isFailedState(state: PrivateOfferStateEnum): boolean {
        switch (state) {
            case PrivateOfferStateEnum.PRECONDITION_FAILED:
            case PrivateOfferStateEnum.QUEST_REJECTED:
            case PrivateOfferStateEnum.QUEST_FAILED:
            case PrivateOfferStateEnum.QUEST_EXPIRED:
            case PrivateOfferStateEnum.OFFER_REJECTED:
            case PrivateOfferStateEnum.OFFER_FAILED:
            case PrivateOfferStateEnum.OFFER_EXPIRED:
            case PrivateOfferStateEnum.CANCELED_BY_ABTEST:
            case PrivateOfferStateEnum.OFFER_CANCELED:
                return true;
            default:
                return false;
        }
    }
}
